<footer class="footer">
  <div class="container">
    <span class="text-muted"> ©2003-{{ year }} Progreso {{ version }} - {{ lbl + '.' }} </span>
    <a class="cursor-pointer ms-4" (click)="goToDisclaimer()" *ngIf="showDisclaimer">
      {{ lblDisclaimer }}
    </a>
    <a class="cursor-pointer ms-4" (click)="openModal(disclaimerModal)" *ngIf="!loggedIn">
      {{ lblDisclaimer }}
    </a>
    <!-- <div *ngIf="isScreenSmall$ | async" class="bottom-navigation-container">
      <app-bottom-navigation-bar></app-bottom-navigation-bar>
    </div> -->

    <ng-template #disclaimerModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title">{{ lblDisclaimer }}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
      </div>
      <div class="modal-body">
        <span [innerHtml]="publicDisclaimer"></span>
      </div>
    </ng-template>
  </div>
</footer>
